import { render, staticRenderFns } from "./mallSpick.vue?vue&type=template&id=fdb00b0e&scoped=true&"
import script from "./mallSpick.vue?vue&type=script&lang=ts&"
export * from "./mallSpick.vue?vue&type=script&lang=ts&"
import style0 from "./mallSpick.vue?vue&type=style&index=0&id=fdb00b0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb00b0e",
  null
  
)

export default component.exports